import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import AccountOrder from '../account-order-history/AccountOrder';
const AccountOrderHistory = ({ orders, loggedIn }) => (_jsx(_Fragment, { children: orders.map((order, index) => (_jsx(AccountOrder, { order: order, isFirstOrder: index === 0, loggedIn: loggedIn }, order.orderId))) }));
export default AccountOrderHistory;
